module.exports = __webpack_public_path__ + "static/media/introduce_base4.f3110b44.png";